import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const JobTag = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M4 21c-.55 0-1.0208-.1958-1.4125-.5875C2.1958 20.0208 2 19.55 2 19v-7h8c0 1.1046.8954 2 2 2s2-.8954 2-2h8v1.7548a3.1752 3.1752 0 00-.175-.0048c-.8127 0-1.5634.31-2.1392.8858l-2.0611 2.0611c-.5705-.5509-1.3055-.8469-2.0997-.8469-.8127 0-1.5634.31-2.1392.8858-.5758.5758-.8858 1.3265-.8858 2.1392 0 .8061.3049 1.5511.8717 2.125H4z"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2 10V8c0-.55.1958-1.0208.5875-1.4125C2.9792 6.1958 3.45 6 4 6h4V4c0-.55.1958-1.0208.5875-1.4125C8.9792 2.1958 9.45 2 10 2h4c.55 0 1.0208.1958 1.4125.5875C15.8042 2.9792 16 3.45 16 4v2h4c.55 0 1.0208.1958 1.4125.5875C21.8042 6.9792 22 7.45 22 8v2H2zm8-4h4V4h-4v2z",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.1 16.05l-3.475 3.475-1.375-1.375c-.2-.2-.4417-.3-.725-.3s-.525.1-.725.3c-.2.2-.3.4417-.3.725s.1.525.3.725l2.125 2.125c.2.2.4333.3.7.3.2667 0 .5-.1.7-.3L22.55 17.5c.2-.2.3-.4417.3-.725s-.1-.525-.3-.725c-.2-.2-.4417-.3-.725-.3s-.525.1-.725.3z"
    })),
    stroke: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2.5875 20.4125C2.9792 20.8042 3.45 21 4 21h7.9626c.0124.0005.0249 0 .0374 0 .5523 0 1-.4477 1-1s-.4477-1-1-1a.9296.9296 0 00-.0374.0007L4 19v-7h6c0 1.1046.8954 2 2 2s2-.8954 2-2h6v1.0391c.0205.5341.4608.9609 1 .9609s.9787-.4268.9993-.9609L22 13V8c0-.55-.1958-1.0208-.5875-1.4125C21.0208 6.1958 20.55 6 20 6h-4V4c0-.55-.1958-1.0208-.5875-1.4125C15.0208 2.1958 14.55 2 14 2h-4c-.55 0-1.0208.1958-1.4125.5875C8.1958 2.9792 8 3.45 8 4v2H4c-.55 0-1.0208.1958-1.4125.5875C2.1958 6.9792 2 7.45 2 8v11c0 .55.1958 1.0208.5875 1.4125zM20 10V8H4v2h16zm-6-4h-4V4h4v2z",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.1 16.05l-3.475 3.475-1.375-1.375c-.2-.2-.4417-.3-.725-.3s-.525.1-.725.3c-.2.2-.3.4417-.3.725s.1.525.3.725l2.125 2.125c.2.2.4333.3.7.3.2667 0 .5-.1.7-.3L22.55 17.5c.2-.2.3-.4417.3-.725s-.1-.525-.3-.725c-.2-.2-.4417-.3-.725-.3s-.525.1-.725.3z"
    })),
    strokertl: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M2.5875 20.4125C2.9792 20.8042 3.45 21 4 21h7.9626c.0124.0005.0249 0 .0374 0 .5523 0 1-.4477 1-1s-.4477-1-1-1a.9296.9296 0 00-.0374.0007L4 19v-7h6c0 1.1046.8954 2 2 2s2-.8954 2-2h6v1.0391c.0205.5341.4608.9609 1 .9609s.9787-.4268.9993-.9609L22 13V8c0-.55-.1958-1.0208-.5875-1.4125C21.0208 6.1958 20.55 6 20 6h-4V4c0-.55-.1958-1.0208-.5875-1.4125C15.0208 2.1958 14.55 2 14 2h-4c-.55 0-1.0208.1958-1.4125.5875C8.1958 2.9792 8 3.45 8 4v2H4c-.55 0-1.0208.1958-1.4125.5875C2.1958 6.9792 2 7.45 2 8v11c0 .55.1958 1.0208.5875 1.4125zM20 10V8H4v2h16zm-6-4h-4V4h4v2z",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.1 16.05l-3.475 3.475-1.375-1.375c-.2-.2-.4417-.3-.725-.3s-.525.1-.725.3c-.2.2-.3.4417-.3.725s.1.525.3.725l2.125 2.125c.2.2.4333.3.7.3.2667 0 .5-.1.7-.3L22.55 17.5c.2-.2.3-.4417.3-.725s-.1-.525-.3-.725c-.2-.2-.4417-.3-.725-.3s-.525.1-.725.3z"
    }))
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
JobTag.displayName = "JobTagIcon";

export { JobTag, JobTag as default };
